import React from 'react'
import PropTypes from 'prop-types'

/** Icon dấu trừ tại màn hình detai_food*/
const SubtractIcon = ({ size = '18', color = 'white' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.06106 8.0611L2.00003 8.0611V10.4853L8.06106 10.4853H10.4853H16.5463V8.0611H10.4853H8.06106Z"
        fill={color}
      />
    </svg>
  )
}

export default React.memo(SubtractIcon)
SubtractIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}
